// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/xdl/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formcheck {\r\n    margin-top: 1% !important;\r\n    font-size: 14px !important;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
